import React from "react";
import { Button, Icon } from "@elaniintc/goes-design-system";

interface AddSectionDividerProps {
  onClick: () => void;
}

const AddSectionDivider: React.FC<AddSectionDividerProps> = ({ onClick }) => (
  <div className="flex items-center gap-3 mt-6 mb-15 justify-center px-4">
    <div className="flex-1 border-t border-neutral-quiet"></div>
    <Button
      variant="ghost"
      onClick={onClick}
      type="button"
      className="text-body-quiet font-semibold text-sm"
    >
      Añadir sección <Icon type="fas" name="plus" />
    </Button>
    <div className="flex-1 border-t border-neutral-quiet"></div>
  </div>
);

export default AddSectionDivider;
